// src/components/formalities/FomalitiesTemplatesSearch.jsx
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import API from "./../../../api";
import { useNavigate } from "react-router-dom";
import { FiChevronRight, FiX } from "react-icons/fi";
import "./formalities-template-search.css";

export default function FomalitiesTemplatesSearch() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef(null);
  const normalize = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  // --- debounce 500 ms ---
  const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  const performSearch = useCallback(
    debounce(async (value) => {
      if (value.length < 3) {
        setResults([]);
        setOpen(false);
        return;
      }
      try {
        setLoading(true);
        const res = await API.post(
          "/formalities/templates/search",
          { q: value }
        );
        setResults(res.data || []);
        setOpen(true);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }, 500),
    []
  );

  const handleChange = (e) => {
    const v = e.target.value;
    setQuery(v);
    performSearch(v);
  };

  // highlight helper
  const highlight = (text, q) => {
    if (!q) return text;

    const normText = normalize(text);
    const normQ = normalize(q);
    const parts = [];
    let start = 0;
    let index;

    while ((index = normText.indexOf(normQ, start)) !== -1) {
      parts.push(text.substring(start, index));
      parts.push(
        `<mark>${text.substring(
          index,
          index + q.length
        )}</mark>`
      );
      start = index + q.length;
    }

    parts.push(text.substring(start));
    return parts.join("");
  };

  const handleSelect = (f) => {
    setOpen(false);
    navigate(`/formalities/request/create/${f.ftId}`);
  };
  // --- click outside ---
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("pointerdown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [open]);

  return (
    <div

      id="formalities-template-search"
      className={[
        "position-relative d-block mx-auto py-3 text-dark",
        open && results.length > 0 ? "opened" : null,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="inner mx-auto" style={{ maxWidth: "600px" }}>
        <div className="position-relative">
          {/* INPUT */}
          <input
            type="text"
            className="form-control form-control-lg border-0"
            placeholder="Ex : Création SAS"
            value={query}
            onChange={handleChange}
            onFocus={() =>
              results.length > 0 && setOpen(true)
            }
          />

          {/* RESULTS */}
          {open && results.length > 0 && (
            <div
              className="suggests position-absolute w-100  pe-2"
              ref={wrapperRef}
              style={{ zIndex: 1000 }}
            >
              {/* CLOSE ICON */}


              {loading && (
                <div className="p-2 text-muted small">
                  Chargement…
                </div>
              )}

              {!loading &&
                results.map((f) => (
                  <div
                    key={f.ftId}
                    className="d-flex align-items-between ps-3  pe-1py-2 pointer"
                    onClick={() => handleSelect(f)}
                  >
                    {/* Col 1 */}
                    <div className="flex-grow-1">
                      <div
                        className="ftName"
                        dangerouslySetInnerHTML={{
                          __html: highlight(
                            f.ftName,
                            query
                          ),
                        }}
                      />
                      <div className="small text-muted">
                        {f.category}
                      </div>
                    </div>

                    {/* Col 3 */}
                    <div>
                      <FiChevronRight
                        size={22}
                        className="text-muted"
                      />
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>

        <span className="small text-muted ps-3">
          3 caractères minimum
        </span>
      </div>
    </div>
  );
}
